import { type FunctionComponent, type SVGProps } from 'react';
import styles from './NeedTile.module.scss';

interface NeedTileProps {
  description: string;
  icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  title: string;
}

const NeedTile = ({ description, icon: Icon, title }: NeedTileProps) => {
  return (
    <div className={styles.tile}>
      <span className={styles.iconWrap} aria-hidden="true">
        <Icon className={styles.icon} />
      </span>
      <h4 className={styles.title}>{title}</h4>
      <div className={styles.desc}>{description}</div>
    </div>
  );
};

export default NeedTile;
